import React from 'react'
import WPGSelect, { WorkplaceGroupItem } from './WPGSelect'
import MultiSelect from './MultiSelect'
import { IWorkplaceGroup } from '@api/types'
import { without } from 'lodash'

interface MultiWPGSelectProps {
  values: IWorkplaceGroup[]
  onChange: (items: IWorkplaceGroup[]) => void
}

export default function MultiWPGSelect({ values, onChange }: MultiWPGSelectProps) {
  const buttonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
  }
  return (
    <MultiSelect
      title="Workplace Group"
      values={values.map((v) => (
        <WorkplaceGroupItem data={v} key={v.id} />
      ))}
      select={
        <WPGSelect
          multi
          value={null}
          itemDisabled={(item) => values.includes(item)}
          onChange={(wpg) => {
            if (wpg) onChange(values.includes(wpg) ? without(values, wpg) : [...values, wpg])
          }}
          placeholder="Add"
          {...{ buttonProps }}
        />
      }
      onRemove={(v) => onChange(values.filter((av) => av.id !== v))}
    />
  )
}
